/**
 * Polling Module
 * Fetches updates once on app open. Real-time updates are handled by
 * socket.io and push notifications — no recurring interval needed.
 */
import { PollingAPI } from '../services/api.js';
import { AppState, CONFIG } from '../config.js';
import { showToast } from '../utils/ui.js';
import { updateNotificationBadge } from './home.js';
import { t } from '../utils/i18n.js';

/**
 * Fetch updates once (called on app startup).
 */
export async function startPolling() {
    if (!AppState.authToken || !AppState.currentUser) return;

    try {
        const lastCheck = new Date(Date.now() - CONFIG.POLLING_INTERVAL).toISOString();
        const response = await PollingAPI.getUpdates(lastCheck);

        if (response && response.updates) {
            handlePollingUpdates(response.updates);
        }
    } catch (error) {
        console.error('Initial poll failed:', error);
    }
}

/**
 * Stop polling (no-op, kept for API compatibility)
 */
export function stopPolling() {}

/**
 * Handle updates received from polling
 */
function handlePollingUpdates(updates) {
    // Update notification badge
    if (updates.stats) {
        updateNotificationBadge(updates.stats.unread_messages);
    }

    // Show new match notifications
    if (updates.new_matches && updates.new_matches.length > 0) {
        updates.new_matches.forEach(match => {
            showToast(t('toast.newMatchWith', { name: match.customer.name }), 'success');
        });
    }

    // Show new message notifications
    if (updates.new_messages && updates.new_messages.length > 0) {
        updates.new_messages.forEach(message => {
            showToast(t('toast.newMessageFrom', { name: message.sender.name }), 'info');
        });
    }

    // Handle other update types as needed
    if (updates.event_updates && updates.event_updates.length > 0) {
        updates.event_updates.forEach(update => {
            showToast(`Event update: ${update.message}`, 'info');
        });
    }
}
